// ============================================
// EDUSICO COLORS - Paleta unificada
// ============================================
// Usar estas constantes en lugar de strings
// hardcodeados para mantener consistencia visual
// en todos los módulos (Bordona, Decimas, etc.)
// ============================================

export const EDUSICO_COLORS = {
  // ─── Acento principal (vino bordona) ───
  accent: "#7B2335",
  accentLight: "#A07840",

  // ─── Acentos por módulo ───
  chordAccent: "#F59E0B",
  scaleAccent: "#FF4D4D",
  modeAccent: "#2DD4BF",
  noteAccent: "#22C55E",
  melodyAccent: "#8B5CF6",
  fingerAccent: "#EC4899",
  songAccent: "#6366F1",
  labAccent: "#F43F5E",
  practiceAccent: "#6B8E5B",

  // ─── Fondos ───
  bgRoot: "#FDF8F0",
  bgPanel: "#FFFFFF",
  bgPanelHover: "#F5F0E8",
  bgWarm: "#FAF6F0",
  bgMuted: "#F0EAE0",

  // ─── Bordes ───
  border: "#DDD5C8",
  borderLight: "#E8E0D4",

  // ─── Texto ───
  textMain: "#2C2825",
  textMuted: "#8A8078",
  textLight: "#B8A99A",
  textOnAccent: "#FFFFFF",

  // ─── Estados ───
  success: "#6B8E5B",
  warning: "#D4BA7A",
  error: "#C44B4B",
  info: "#5BA8A8",

  // ─── Mástil ───
  neckRoot: "#FF4D4D",
  neckThird: "#2DD4BF",
  neckFifth: "#22C55E",
  neckSeventh: "#C49B4A",
  neckActive: "#FF4D4D",
  neckMuted: "#B8A99A",
} as const;

export type EdusicoColor = keyof typeof EDUSICO_COLORS;
